export default "__VITE_ASSET__BDfe_DQ$__"